import { render, staticRenderFns } from "./EmArchScrapProcessAspEdit.vue?vue&type=template&id=2b05836b&"
import script from "./EmArchScrapProcessAspEdit.vue?vue&type=script&lang=js&"
export * from "./EmArchScrapProcessAspEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports